import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { 
  FaHeartbeat, 
  FaEye, 
  FaBicycle, 
  FaTractor,
  FaRunning,
  FaArrowRight 
} from "react-icons/fa";
import { GiSewingMachine } from "react-icons/gi";

import Water from "./DrinkingWater";
import Latest from "../Assests/latest.png";
import "./HomeContent.css";

const ServiceCard = ({ bg, text, icon: Icon, delay, path, onClick }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  const handleClick = () => {
    if (onClick) onClick(path);
  };

  return (
    <Col lg={4} md={6} sm={6} xs={12} className="service-col">
      <div 
        className={`service-card ${isVisible ? 'animate-card' : ''}`}
        style={{ background: `linear-gradient(135deg, ${bg} 0%, ${bg}cc 100%)` }}
        onClick={handleClick}
      >
        <div className="card-glow"></div>
        <div className="service-icon-container">
          <Icon className="service-icon" />
        </div>
        <div className="service-text-container">
          <p className="service-text">{text}</p>
        </div>
        <div className="card-hover-effect">
          <FaArrowRight className="hover-arrow" />
        </div>
      </div>
    </Col>
  );
};

const HomeContent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleServiceClick = (path) => {
    if (path) {
      navigate(path);
    } else {
      // Scroll to contact section or open modal
      const contactSection = document.getElementById('contact-section');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const services = [
    { 
      bg: "#207FB7", 
      text: t('Free_Health_Checkup'), 
      icon: FaHeartbeat, 
      delay: 100,
      path: "/health-camp-form",
      description: "Free health checkup camps for rural communities"
    },
    { 
      bg: "#DB0C22", 
      text: t('Free_Cataract_Surgery'), 
      icon: FaEye, 
      delay: 200,
      path: "/cataract-camp-form",
      description: "Free cataract surgery for elderly patients"
    },
    { 
      bg: "#08B749", 
      text: t('Tricycle_Distribution'), 
      icon: FaBicycle, 
      delay: 300,
      path: "/tricycle-form",
      description: "Tricycles for differently-abled individuals"
    },
    { 
      bg: "#FFA800", 
      text: t('Modern_Agriculture_Equipments_for_Farmers'), 
      icon: FaTractor, 
      delay: 400,
      path: "/farmer-form",
      description: "Modern farming equipment for farmers"
    },
    { 
      bg: "#3F00C0", 
      text: t('Sewing_Machines_for_Women_Empowerment'), 
      icon: GiSewingMachine, 
      delay: 500,
      path: "/sewing-machine-form",
      description: "Sewing machines for women empowerment"
    },
    { 
      bg: "#FF5800", 
      text: t('title3'), 
      icon: FaRunning, 
      delay: 600,
      path: "/running-competition-form",
      description: "Sports events and competitions for youth"
    }
  ];

  return (
    <div className="home-content-wrapper">
      {/* Services Section */}
      <div className="services-section">
        <div className="services-bg-pattern">
          <Container>
            <div className="section-header">
              <span className="section-badge">Our Services</span>
              {/* <h2 className="section-title">
                What We <span className="highlight">Do</span>
              </h2> */}
              <p className="section-subtitle">
                Transforming lives through dedicated service and community support
              </p>
              <div className="section-divider">
                <span className="divider-line"></span>
                <span className="divider-diamond">◆</span>
                <span className="divider-line"></span>
              </div>
            </div>
            
            <Row className="services-row">
              {services.map((service, idx) => (
                <ServiceCard 
                  key={idx} 
                  {...service} 
                  onClick={handleServiceClick}
                />
              ))}
            </Row>
          </Container>
        </div>
      </div>

      {/* Latest News Banner */}
      <div className="news-banner">
        <Container>
          <div className="news-wrapper">
            <div className="news-content">
              <span className="news-label">
                <span className="label-text">Latest News</span>
                <span className="label-dot"></span>
              </span>
              <div className="news-ticker">
                <div className="ticker-wrapper">
                  <div className="ticker-marquee">
                    Your kind acts of donation/help have gifted many people in society to get chance at batter life. We thank you for being  the change this country needs.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
 
      <Water />
    </div>
  );
};

export default HomeContent;